<template>
  <div class="breadcrumb">
    <!--<div class="bar"></div>
    <ul class="items">
      <li class="item -validated" @click="onClickIntro()">
        <span>Intro</span>
        <div class="point">
          <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
        </div>
      </li>
      <li class="item" v-for="(question, index) in summary" :class="{ '-active': (index === (summary.length - 1) && !isResults), '-validated': (index < (summary.length - 1) || isResults) }"  @click="onClickSummary(index)">
        <span>{{ `${question.short_title}` }}</span>
        <div class="point">
          <svg class="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
        </div>
      </li>
      <li class="item" :class="(isResults) ? '-active' : '-disabled'">
        <span>Résultat</span>
        <div class="point"></div>
      </li>
    </ul>-->
    <div class="previous" @click="onClickPrevious">
      <div class="point">
        <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 18">
          <path d="M9.71 17.71a1 1 0 01-1.32.08l-.1-.08-8-8a1 1 0 01-.08-1.32l.08-.1 8-8a1 1 0 011.42 0 1 1 0 01.08 1.32l-.08.1L2.42 9l7.29 7.29a1 1 0 01.08 1.32z"/>
        </svg>
      </div>
      <span>Étape précédente</span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'Breadcrumb',
  props: {},
  computed: {
    ...mapState([
        'summary',
        'isResults'
    ])
  },
  methods: {
    ...mapActions([
        'GOTO_INTRO',
        'GOTO_SUMMARY',
        'GOTO_PREVIOUS',
        'SET_STARTED'
    ]),
    onClickSummary(index) {
      this.GOTO_SUMMARY(index)
    },
    onClickIntro() {
      this.GOTO_INTRO()
    },
    onClickPrevious() {
      if (this.summary.length > 1) {
        this.GOTO_PREVIOUS(this.isResults)
      } else {
        this.GOTO_INTRO()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables';

.breadcrumb {
  position: relative;
  width: 100%;
  max-width: 650px;

  .bar {
    position: relative;
    display: flex;
    flex-direction: row;
    height: 0.2rem;
    background-color: $white;
    width: 100%;
  }

  .items {
    position: absolute;
    top: -1rem;
    left: 0;
    width: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;


    .item {
      position: relative;
      font-size: 1.4rem;
      cursor: pointer;

      /*&:nth-of-type(2n) {
        span {
          top: auto;
          bottom: -3rem;
        }
      }*/

      span {
        position: absolute;
        top: -2.5rem;
        left: 50%;
        transform: translateX(-50%);
      }

      .point {
        position: relative;
        left: 0;
        bottom: 0;
        width: 2rem;
        height: 2rem;
        background-color: $white;
        border-radius: 1rem;

        .icon {
          display: none;
          stroke: $blue;
        }
      }


      &:first-child {
        transform: translateX(-50%);
      }

      &:last-child {
        transform: translateX(50%);
      }

      &.-active, &:hover {
        .point {
          background-color: $blue;
          border: 0.2rem solid $white;

          .icon {
            display: none !important;
          }
        }
      }

      &.-disabled {
        display: none;
        pointer-events: none;
      }

      &.-validated {
        .point {
          .icon {
            display: block;
          }
        }
      }
    }

  }

  .previous {
    // margin-top: 5rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    text-decoration: underline;

    .point {
      position: relative;
      width: 1rem;
      height: 1rem;

      .icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        fill: $white;
        transition: transform 0.3s ease-out;
      }
    }

    span {
      margin-top: 0.4rem;
      margin-left: 0.5rem;
      font-size: 1.4rem;
      line-height: 1rem;
    }

    &:hover {
      .point {
        .icon {
          transform: translateX(-5px);
        }
      }
    }
  }
}

</style>
